export const hy = {
  title: 'Անձեռնմխելի անտառային լանդշաֆտներ',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Գործառույթ',
      value:
        'Բացահայտում է աշխարհի վերջին չհատված անտառային լանդշաֆտները, որոնք բավականաչափ մեծ են, որպեսզի պահպանեն ողջ բնիկ կենսաբազմազանությունը և 2020 թվականի դրությամբ մարդկային փոփոխության նշաններ ցույց չեն տալիս: Այս շերտը նաև ցույց է տալիս անձեռնմխելի անտառային լանդշաֆտների ծավալի կրճատումը 2000-ից մինչև 2020 թվականը:',
    },
    {
      label: 'Բանաձեւ',
      value: 'Մոտավորապես 1:1000000',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Համաշխարհային',
    },
    {
      label: 'Աղբյուր',
      value:
        'Պոտապով, Պ., Մ. Կ. Հանսեն, Լ. Լաեստադիուս, Ս. Տուրուբանովա, Ա. Յարոշենկո, Կ. Թիս, Վ. Սմիթ, Ի. Ժուրավլևա, Ա. Կոմարովա, Ս. Մինեմայեր և Է. Էսիպովա: 2017. «Վայրի բնության վերջին սահմանները. Հետևելով անձեռնմխելի անտառային լանդշաֆտների կորստին 2000-ից մինչև 2013 թվականը»: Գիտության առաջընթաց 3. e1600821:',
    },
    {
      label: 'Հաճախականություն',
      value: '2020 թ',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value:
        'Համաշխարհային IFL քարտեզը ստեղծվել է փորձագետների կողմից Landsat-ի պատկերների տեսողական մեկնաբանության միջոցով: Քարտեզը կարող է պարունակել անճշտություններ՝ կապված պատկերների տարածական լուծաչափի սահմանափակումների և որոշ շրջաններում հողօգտագործման տեղական պրակտիկայի մասին օժանդակ տեղեկատվության բացակայության հետ: Բացի այդ, մեթոդաբանությունը ենթադրում է, որ ճանապարհներին կամ այլ ենթակառուցվածքներին հարևանությամբ բռնկված հրդեհները կարող են առաջանալ մարդկանց կողմից և, հետևաբար, հանդիսանում են մարդածին խանգարումների ձև: Այս ենթադրությունը կարող է հանգեցնել IFL-ի տարածման թերագնահատմանը բորեալ բիոմում:',
    },
    {
      label: 'Զգուշացումներ',
      value: 'CC BY 4.0',
    },
    {
      label: 'Լիցենզիա',
      value:
        'Անձեռնմխելի անտառային լանդշաֆտների (IFL) տվյալների հավաքածուն բացահայտում է բնական էկոհամակարգերի անխափան տարածությունները անտառային տարածության գոտում, որոնք ցույց չեն տալիս մարդկային նշանակալի գործունեության նշաններ և բավականաչափ մեծ են, որ ողջ բնիկ կենսաբազմազանությունը, ներառյալ լայն տեսականի կենսունակ պոպուլյացիաները, կարող են պահպանվել: IFL-ի տարածքները քարտեզագրելու համար մշակվել և նախագծվել է մի շարք չափանիշներ, որոնք գլոբալ կիրառելի և հեշտությամբ վերարտադրելի են, վերջիններս թույլ են տալիս ժամանակի ընթացքում կրկնվող գնահատումներ, ինչպես նաև ստուգումներ: IFL տարածքները սահմանվել են որպես չհատված լանդշաֆտներ՝ առնվազն 50,000 հեկտարի չափով և նվազագույնը 10 կիլոմետր լայնությամբ: Դրանք այնուհետև քարտեզագրվեցին Landsat արբանյակային պատկերներից 2000 թվականի համար:',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Գրինփիս, Մերիլենդի համալսարան, Համաշխարհային ռեսուրսների ինստիտուտ և Թափանցիկ աշխարհ: «Անտառային անձեռնմխելի լանդշաֆտներ. 2000/2013/2016/2020» Մատչելի է Global Forest Watch-ի միջոցով 31/01/2025-ին: www.globalforestwatch.org',
  },
  citation: {
    label: 'Մեջբերում',
    value: 'Sağlam Meşə Mənzərələri',
  },
};
